module.exports = __webpack_public_path__ + "img/step6-08.d6f73b9d.jpg";